import Vue from 'vue'
import Router from 'vue-router'
import maErrorView from '@/views/error'
import maOtpView from '@/views/otp'
import maTimedoutView from '@/views/timedout'
import maFnolFlow from '@/views/fnolFlow'
import PrivacyPolicy from '@/views/privacyPolicy'
import { claimRouter } from '@/modules/Claim'
import { damageRouter } from '@/modules/Damage'
import { appointmentRouter } from '@/modules/Appointment'
import { documentRouter } from '@/modules/Document'
import jwtDecode from 'jwt-decode'
import { apiPostValidateOtp } from '@/modules/User/services/authentication'
import tokenVerification from '@/utils/tokenVerification'
/**
 * @module
 * @name Router
 */

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    ...claimRouter,
    ...damageRouter,
    ...appointmentRouter,
    ...documentRouter,
    {
      path: '/otp',
      name: 'otp',
      component: maOtpView
    },
    {
      path: '/timedout',
      name: 'timedout',
      component: maTimedoutView
    },
    {
      path: '/error',
      name: 'error',
      component: maErrorView
    },
    {
      path: '/fnol-flow',
      name: 'fnol-flow',
      component: maFnolFlow
    },
    {
      path: '/scencrypt/:scencryptId',
      name: 'scencrypt'
    },
    {
      path: '/selfcareInit',
      name: 'initialPath'
    },
    {
      path: '/privacy-policy',
      name: 'privacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '*',
      redirect: 'error'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: -6 }
  }
})
router.navigationHistory = []

let isNavigatingBack = false

window.addEventListener('popstate', () => {
  isNavigatingBack = true
})

router.beforeEach(async (to, from, next) => {
  if (isNavigatingBack && from.name === 'damages-view') {
    isNavigatingBack = false
    return
  }

  if (from?.name) {
    router.navigationHistory.push(from.name)
  }

  const token = sessionStorage.getItem('mavAuth')
  if (token && tokenVerification(token)) {
    const decodedToken = jwtDecode(token)
    const currentTime = Date.now() / 1000
    const timeLeft = decodedToken.exp - currentTime

    if (timeLeft < 60) {
      sessionStorage.setItem('mavAuth', null)
      const sinisterID = sessionStorage.getItem('sinId')
      const otpCode = sessionStorage.getItem('otpCode')
      const token = await apiPostValidateOtp(sinisterID, otpCode, true)
      if (token) {
        sessionStorage.setItem('mavAuth', `Token ${token.token}`)
      }
    }
  }
  next()
})

export default router
